import React from 'react'
import { connect } from 'react-redux'
import { Field, InjectedFormProps, reduxForm } from 'redux-form'
import { fetchConfigurations } from '../../actions/configurationActions'
import { Configuration } from '../../core/types'
import LoaderButton from '../../components/loaderButton'
import { InputField, SelectField, StateSelect } from '../../components/inputs'

interface OrganizationFormOwnProps {
  onSubmit: (values: any) => void
}

type OrganizationFormProps = InjectedFormProps<any, OrganizationFormOwnProps> &
  OrganizationFormOwnProps & {
    configurations: Configuration[]
    dispatch: any
  }

class OrganizationFormComponent extends React.Component<OrganizationFormProps> {
  componentDidMount(): void {
    this.props.dispatch(fetchConfigurations())
  }

  render() {
    const { handleSubmit, submitting, onSubmit, configurations } = this.props
    return (
      <form className="form" onSubmit={handleSubmit(onSubmit)}>
        <Field name="addressId" component={InputField as any} type="hidden" />
        <Field name="code" label="Code" component={InputField as any} />
        <Field
          name="nameLegal"
          label="Legal Name"
          component={InputField as any}
        />
        <Field name="nameDba" label="DBA Name" component={InputField as any} />
        <Field
          name="contactEmail"
          label="Contact Email"
          type="email"
          component={InputField as any}
        />
        <Field
          name="contactPhone"
          label="Contact Phone"
          component={InputField as any}
        />
        <Field
          name="configurationId"
          label="Configuration"
          component={SelectField as any}
        >
          <option />
          {configurations.map((c) => (
            <option key={c.id} value={c.id}>
              {`${c.callCenterName || 'Configuration'} (#${c.id})`}
            </option>
          ))}
        </Field>

        <fieldset>
          <legend>Address</legend>
          <Field
            name="addressLine1"
            label="Address Line 1"
            component={InputField as any}
          />
          <Field
            name="addressLine2"
            label="Address Line 2"
            component={InputField as any}
          />
          <Field name="city" label="City" component={InputField as any} />
          <StateSelect label="State" name="state" defaultOption="Select a state" />
          <Field name="zip" label="Zip" component={InputField as any} />
        </fieldset>

        <hr className="form__hr" />
        <div className="form__group">
          <LoaderButton
            type="submit"
            className="button button--primary"
            isLoading={submitting}
          >
            Save
          </LoaderButton>
        </div>
      </form>
    )
  }
}

const ConnectedForm = connect((state: any) => ({
  configurations: (state.configurations && state.configurations.all) || [],
}))(OrganizationFormComponent)

export default reduxForm<any, OrganizationFormOwnProps>({
  form: 'organizationForm',
  enableReinitialize: true,
  destroyOnUnmount: true,
})(ConnectedForm)
